export default __webpack_public_path__ + "static/media/duo_with_dancers_3.0418cc2c.jpg";